/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubmissionStatus = {
    Pending: 'pending',
    Replied: 'replied',
    NoSize: 'no_size',
    NoFish: 'no_fish',
    NoMedia: 'no_media',
    NonImageMedia: 'non_image_media',
    Undecodable: 'undecodable',
    DeclinedUnknown: 'declined_unknown',
    Failed: 'failed',
} as const;
export type SubmissionStatus = typeof SubmissionStatus[keyof typeof SubmissionStatus];


export function instanceOfSubmissionStatus(value: any): boolean {
    for (const key in SubmissionStatus) {
        if (Object.prototype.hasOwnProperty.call(SubmissionStatus, key)) {
            if (SubmissionStatus[key as keyof typeof SubmissionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubmissionStatusFromJSON(json: any): SubmissionStatus {
    return SubmissionStatusFromJSONTyped(json, false);
}

export function SubmissionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionStatus {
    return json as SubmissionStatus;
}

export function SubmissionStatusToJSON(value?: SubmissionStatus | null): any {
    return value as any;
}

export function SubmissionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SubmissionStatus {
    return value as SubmissionStatus;
}

